import {ChartData} from "../chart-data";

export class ChartGetDataModel {
    constructor(
        public readonly GUID: string,
        public readonly sharedGUID: string,
        public readonly type: string,
        public itemId: number,
        public startDate: string,
        public endDate: string
    ){}
}

export class ChartSetDataModel {
    constructor(
        public GUID: string,
        public type: string,
        public data: ChartData
    ){}
}

export class GUIDChartsDataModel {
    constructor(){}

    public main: ChartGetDataModel[];
    public info: ChartGetDataModel[];
}

export class GUIDChartDataModel {
    constructor(
        public GUID: string,
        public itemId: number,
    ){}
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/amchart/chart-exchange.ts